import '.a{display:flex;}.ssr-plugin'
import '.a0{flex-direction:row;}.ssr-plugin'
import '.ah{background-color:var(--palette-white);}.ssr-plugin'
import '.a5{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.bb{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.bc{margin-top:2rem;}.ssr-plugin'
import '.ad{margin-bottom:5rem;}.ssr-plugin'
import '.bd{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <div className="a a0 ah"
      >
        <InitiativeSideBar />
        <div className="a5 a f b e"
          style={{
            marginLeft: isMobile ? '3.25rem' : '14rem', // left bar
          }}
        >
          <DashboardNavBar
            initiativeDashboard={true}
            style={{ backgroundColor: 'var(--palette-white)' }}
          />
          <div className="bb a e ae bc ad bd"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '60%', // 12rem is padding + navbar height
              paddingInline: isMobile ? '1rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
